import {DictionaryData, SubFirmDictionary} from "./subfirm/Dictionary";

export class CalendarCar {

  carDefault = {
    name: 'Mặc định',
    uuid: ''
  };

  carRef: string = 'CAL_BUILDER_CAR';
  driverRef: string = 'CAL_BUILDER_DRIVER';

  subFirmDict: SubFirmDictionary;

  constructor(subFirmDict: SubFirmDictionary) {
    this.subFirmDict = subFirmDict;
  }

  loadCars(callback: Function) {
    this._loadList(this.carRef, callback);
  }

  createOrUpdateCars(data: DictionaryData, callback: Function) {
    if (!data.uuid) {
      data.name = this.carRef;
      data.reference = this.carRef;
      this.subFirmDict.create(data, (data: any) => this.parseJsonValue(data, callback));
    } else {
      this.subFirmDict.update(data, (data: any) => this.parseJsonValue(data, callback));
    }
  }

  loadDrivers(callback: Function) {
    this._loadList(this.driverRef, callback);
  }

  createOrUpdateDrivers(data: DictionaryData, callback: Function) {
    if (!data.uuid) {
      data.name = this.driverRef;
      data.reference = this.driverRef;
      this.subFirmDict.create(data, (data: any) => this.parseJsonValue(data, callback));
    } else {
      this.subFirmDict.update(data, (data: any) => this.parseJsonValue(data, callback));
    }
  }

  _loadList(ref: string, callback: Function) {
    this.subFirmDict.list(ref, (results: any) => this.parseJsonValue(results[0], callback));
  }

  parseJsonValue(data: DictionaryData, callback: Function) {
    if(data && data.value) {
      let values = [];
      try {
        values = JSON.parse(data.value);
      } catch (e) {

      }
      callback(values, data);
    }
  }
}
